import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
};

const initData = {
    items: [],
    planned_start_date: getTodayDate(),
};

const statuses = []

function ShipmentDistributor({ modal, setModal }) {
    const { t } = useTranslation();

    const [sendData, setSendData] = useState({ ...initData });

    const [distributors, setDistributors] = useState([])
    const [fgItems, setFgItems] = useState([])
    const [units, setUnits] = useState([])

    async function create() {
        var sendDataCopy = { ...sendData }
        const response = await POST('/production/orders/', sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData })
        }
    }

    const handleDateChange = (date, fieldName) => {
        const formattedDate = date ? date.toISOString().split('T')[0] : '';
        setSendData(prev => ({
            ...prev,
            [fieldName]: formattedDate
        }));
    };

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    function selectFgItem(option, index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.items[index].id = option?.id;
        setSendData(sendDataCopy);
    }

    function handleChangeItem(e, index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.items[index][e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    function deleteItem(index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.items.splice(index, 1)
        setSendData(sendDataCopy);
    }

    function addToList() {
        var sendDataCopy = { ...sendData };
        sendDataCopy.items.push({})
        setSendData(sendDataCopy);
    }


    useEffect(() => {
        async function getDistributors() {
            const response = await GET('/sales/distributors/')
            if (httpOk(response)) {
                setDistributors(response.data)
            }
        }

        async function getFgItems() {
            const response = await GET('/inventory/fg-warehouse/items/', { size: 1000 })
            if (httpOk(response)) {
                setFgItems(response.data.results)
            }
        }

        async function getUnits() {
            const response = await GET('/catalogs/units/')
            if (httpOk(response)) {
                setUnits(response.data)
            }
        }

        getDistributors()
        getFgItems()
        getUnits()
    }, []);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('distributor_shipment')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('create_shipment_document_desc')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('distributor')}</label>
                        <CustomSelect
                            options={distributors}
                            value={distributors?.find(option => option.id === sendData?.product_id) || ''}
                            onChange={(option) => setSendData({ ...sendData, product_id: option.id, unit_id: option.unit_id })}
                            placeholder={t('select_distributor')}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('order_number_optional')}</label>
                        <input type="text" placeholder='SO-2025-XXXX' name="order_number"
                            value={sendData.order_number} onChange={(e) => handleChange(e)} />
                    </div>

                    <div className="grid2 gap-16">
                        <div className="form-group">
                            <label>{t('planned_volume')}</label>
                            <input type="text" placeholder='0' name="planned_quantity"
                                value={sendData.planned_quantity} onChange={(e) => handleChange(e)} />
                        </div>
                        <div className="form-group">
                            <label>{t('unit_of_measurement')}</label>
                            <CustomSelect
                                options={units}
                                value={units?.find(option => option.id === sendData?.unit_id) || ''}
                                onChange={(option) => setSendData({ ...sendData, unit_id: option.id })}
                                placeholder={t('unit_short')}
                            />
                        </div>
                    </div>

                    <div className="card forth">
                        <div className="d-between mb-16">
                            <div>
                                {t('items_to_ship')}
                            </div>
                            <button className="white small" onClick={() => addToList()}>
                                <PlusIcon />
                                {t('add_item')}
                            </button>
                        </div>

                        <div className="d-flex flex-column gap-12">
                            {sendData?.items?.map((item, index) => (
                                <div className="d-flex gap-8" key={index}>
                                    <div style={{ minWidth: '230px', }}>
                                        <CustomSelect
                                            options={fgItems}
                                            value={fgItems?.find(option => option.id === item?.id) || ''}
                                            getOptionLabel={(option) => option.product_name}
                                            onChange={(option) => selectFgItem(option, index)}
                                            placeholder={t('sku')}
                                            isClearable={false}
                                        />
                                    </div>

                                    <input type="text" placeholder={t('quantity')} name="quantity" className="w-100"
                                        value={item.quantity} onChange={(e) => handleChangeItem(e, index)} />

                                    <button className="transparent small" style={{ height: '36px' }} onClick={() => deleteItem(index)}>
                                        {t('delete')}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="grid2 gap-16">
                        <div className="form-group">
                            <label>{t('shipment_date')}</label>
                            <DatePicker
                                portalId="root"
                                selected={sendData.planned_start_date ? new Date(sendData.planned_start_date) : null}
                                onChange={(date) => handleDateChange(date, 'planned_start_date')}
                                dateFormat="yyyy-MM-dd"
                                placeholderText={t('select_date')}
                            />
                        </div>
                        <div className="form-group">
                            <label>{t('unit_of_measurement')}</label>
                            <CustomSelect
                                options={statuses}
                                value={statuses?.find(option => option.id === sendData?.status) || ''}
                                onChange={(option) => setSendData({ ...sendData, status: option.id })}
                                placeholder={t('unit_short')}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>{t('comment')}</label>
                        <input type="text" placeholder={t('additional_info')} name="comment"
                            value={sendData.comment} onChange={(e) => handleChange(e)} />
                    </div>

                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('ship')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default ShipmentDistributor